export const enum CommonActionType {
  LOADING = 'LOAD',
  COMPLETE = 'COMPLETE',
}
